import React, {useEffect, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import {medicalSuppliesService, pharmacyStoreService, storeService} from "api";
import {InputFields} from "components/common";
import {dataFields} from "./config";
import Notification from "components/common/notification/notification";
import {
  convertDateStringToDateTimezone_7,
  convertIosStringToDateDayjs,
  convertIosStringToDateObjectDayjs,
  formatDateToString,
  formatDateToStringTimezone_7,
} from "helper/common";
import {
  getStoreVTYTSearchKeyAPI,
  medicalSuppliesStore,
} from "redux/reducer/medicalSupplies";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {FORMAT_TIME} from "types/enums";

const ModalContent = props => {
  const dispatch = useAppDispatch();
  const {data, closeModal, type, getListBidDecision, nameCatalog} = props;
  console.log("data", data);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );
  const [fields, setFields] = useState<any>(dataFields);
  useEffect(() => {
    dispatch(getStoreVTYTSearchKeyAPI({}));
  }, []);
  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue({
        ...data,
        announced: convertIosStringToDateDayjs(data?.announced),
        tuNgay: convertDateStringToDateTimezone_7(data?.tuNgay),
        denNgay: convertDateStringToDateTimezone_7(data?.denNgay),
        hanSYT: convertDateStringToDateTimezone_7(data?.hanSYT),
      });
      form.setFieldValue("vtytIds", data?.bidVTYTDtos?.[0]?.vtytId);
    }
  }, [data]);
  const formatData = () => {
    return {
      ...form.getFieldsValue(),
      vtytIds: [form.getFieldValue("vtytIds")],
      tuNgay: formatDateToString(
        formatDateToStringTimezone_7(form.getFieldValue("tuNgay"), true),
        FORMAT_TIME.dayFullInputRevert
      ),
      denNgay: formatDateToString(
        formatDateToStringTimezone_7(form.getFieldValue("denNgay"), true),
        FORMAT_TIME.dayFullInputRevert
      ),
      hanSYT: formatDateToString(
        formatDateToStringTimezone_7(form.getFieldValue("hanSYT"), true),
        FORMAT_TIME.dayFullInputRevert
      ),
      type: "VTYT",
    };
  };
  const addBidDecision = async () => {
    setLoading(true);
    try {
      const data = formatData();
      await medicalSuppliesService.addBidDecision(data);
      setLoading(false);
      closeModal();
      Notification("success", `Đã thêm ${nameCatalog} mới`);
      await getListBidDecision();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi thêm mới ${nameCatalog}`
      );
    }
  };
  const editBidDecision = async () => {
    setLoading(true);
    try {
      const data = formatData();
      await medicalSuppliesService.editBidDecision(data);
      setLoading(false);
      Notification("success", `Đã sửa thông tin ${nameCatalog}`);

      closeModal();
      await getListBidDecision();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi sửa thông tin ${nameCatalog}`
      );
    }
  };

  useEffect(() => {
    const setOptions = list => {
      console.log(list);
      dataFields.find(field => field.name === "vtytIds").options = list?.map(
        item => ({
          value: item.id,
          label: `${item.id} - ${item.tenTheoThuongMai}`,
        })
      );
      setFields([...dataFields]);
    };
    setOptions(medicalSuppliesStore.vTYTSearchKeyList);
  }, [medicalSuppliesStore.vTYTSearchKeyList]);
  const onFinish = values => {
    if (type == "Thêm") {
      addBidDecision();
    } else {
      editBidDecision();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={fields}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default ModalContent;
